import styled from 'styled-components';
// ui
import { Flex } from '../../ui';
//////////////////////////////////////////////////

const HeaderCellWrapper = styled(Flex)`
  height: 100%;
  font-size: 13px;
  text-transform: uppercase;
  font-Family: Roboto-Medium, serif;
  background-color: ${({ theme }) => `${theme.colors.middleGrey}`};

  & .a-icon {
    visibility: ${({ isActive }) => (isActive ? 'visible' : 'hidden')};
  }

  &:hover {
    & .a-icon {
      visibility: visible;
    }
  }
`;

const ResultActionsWrapper = styled(Flex)`
  width: 100%;
  height: 100%;
  padding-right: 16px;
  gap: 16px;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;

  &:not(:hover) > div:last-child i:last-child {
    visibility: hidden;
  }
`;

const CommitActionsWrapper = styled(Flex)`
  width: 100%;
  height: 100%;
  padding-right: 16px;
  gap: 16px;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
`;

const CompanyHoverWrapper = styled(Flex)`
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;

  &:not(:hover) > div:first-child i:last-child {
    visibility: hidden;
  }
`;

export {
  HeaderCellWrapper,
  CompanyHoverWrapper,
  CommitActionsWrapper,
  ResultActionsWrapper,
};
